type SectionHeadingProps = {
  number: string;
  eyebrow: string;
  title: string;
  description?: string;
  align?: "start" | "center";
};

export function SectionHeading({ number, eyebrow, title, description, align = "start" }: SectionHeadingProps) {
  return (
    <header className={`section-heading section-heading-${align}`}>
      <div className="section-kicker">
        <span className="panel-number">{number}</span>
        <span>{eyebrow}</span>
      </div>
      <h2>{title}</h2>
      {description && <p>{description}</p>}
    </header>
  );
}
